import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../utils/api';
import { useAuth } from './AuthContext';

const PermCtx = createContext(null);

export function PermissionsProvider({ children }) {
  const { user } = useAuth();
  const [permissions, setPermissions] = useState({});
  const [loaded, setLoaded] = useState(false);

  const load = useCallback(async () => {
    if (!user) { setPermissions({}); setLoaded(true); return; }
    try {
      const res = await api.get('/auth/my-permissions');
      setPermissions(res.data.data.permissions || {});
    } catch { setPermissions({}); }
    finally { setLoaded(true); }
  }, [user]);

  useEffect(() => { setLoaded(false); load(); }, [load]);

  // can('students', 'create')
  const can = useCallback((module, action) => {
    if (user?.role === 'super_admin') return true;
    return !!(permissions[module] && permissions[module][action]);
  }, [permissions, user]);

  // canView('students')
  const canView = useCallback((module) => can(module, 'view'), [can]);

  return (
    <PermCtx.Provider value={{ permissions, can, canView, loaded, reload: load }}>
      {children}
    </PermCtx.Provider>
  );
}

export function usePermissions() { return useContext(PermCtx); }
